(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignQuestionnaireListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'externalParty', 'campaign'];

    function Controller($scope, $state, externalParty, campaign) {
        $scope.externalParty = externalParty;
        $scope.campaign = campaign;

        $scope.goToExternalParty = function () {
            $state.go('odd.externalPartyEdit');
        };

        $scope.goToCampaign = function () {
            $state.go('odd.externalPartyEdit.campaign', { ODDCampaignID: campaign.ODDCampaignID }, { reload: true });
        };
    }
})();